import { lazy } from 'react';

import FederatedApp from './Components/FederatedApp';

const FederatedBankingWidgetV2Entry = lazy(() => import('./Components/FederatedBankingWidgetV2'));
const FederatedAppV2Entry = lazy(() => import('./Components/FederatedAppV2'));

export const FederatedBankingWidgetV2 = (props) => <FederatedBankingWidgetV2Entry {...props} />;
export const FederatedAppV2 = (props) => <FederatedAppV2Entry {...props} />;

// Host component: https://github.com/zenbusiness/zendash/blob/main/src/components/BankOfAmericaOfferModal/index.js
export const BankOfAmericaOfferModal = lazy(
  () =>
    import(
      /* webpackChunkName: 'banking-federated-components' */ './Components/BankOfAmericaOfferModalEntry'
    )
);

export default FederatedApp;
